// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__L2Cd5","comment":"styles_comment__26Kau"};